import { createClient } from '@supabase/supabase-js'
import { Database } from './database.types'
// These should be environment variables in a production app
const supabaseUrl = 'https://eoktsarockavjdsxqhjm.supabase.co'
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImVva3RzYXJvY2thdmpkc3hxaGptIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDcwMjc2MzksImV4cCI6MjAyMjYwMzYzOX0.eBtxNzxttv8KE5nG1YnZ9ELB0VCEyVJXlv0Rjr1v2wk'
// Create a single supabase client for interacting with your database
export const supabase = createClient<Database>(supabaseUrl, supabaseAnonKey)